import ContentLayout from "../components/UI/Layout/ContentLayout.tsx";
import { Tabs } from "../components/UI/Tabs/Tabs";
import PageLayout from "../components/UI/Layout/PageLayout";
import Impersonate from "../components/Auth/Impersonate";
import EdlTemplateShow from "../components/Edl/EdlTemplateShow";
import CourrierShow from "../components/Courrier/CourrierShow";
import MailShow from "../components/Mail/MailShow";
import Webhooks from "../components/Admin/Oodrive/Webhooks";
import Map from "../components/Admin/Map";
import AdminFactures from "../components/Admin/AdminFactures";
import Promos from "../components/Admin/Promos";
import Imports from "../components/Admin/Imports";
import Scripts from "../components/Admin/Scripts";
import AdminPennylane from "../components/Admin/AdminPennylane";
import BandeauInformationAdmin from "../components/Admin/BandeauInformationAdmin";

import useAuth from "../hooks/use-auth.js";
import HeaderLayout from "../components/UI/Layout/HeaderLayout.tsx";

function AdminPage() {
  const { auth } = useAuth();
  return (
    <PageLayout isBailleur>
      <ContentLayout
        header={<HeaderLayout title={"Administration"} />}
        body={
          <Tabs id="admin" defaultValue="impersonate">
            <div className="container bg-blue paddingT10 border-blue">
              <div className="content">
                <Tabs.List>
                  {(auth?.role?.includes("impersonate") ||
                    auth?.role?.includes("toCall")) && (
                    <Tabs.Tab value="impersonate">Comptes</Tabs.Tab>
                  )}
                  {auth?.role?.includes("edlTemplate") && (
                    <Tabs.Tab value="edl-template">EDL Template</Tabs.Tab>
                  )}
                  {auth?.role?.includes("courriers") && (
                    <>
                      <Tabs.Tab value="courriers">Courriers</Tabs.Tab>
                      <Tabs.Tab value="cautions">Cautions</Tabs.Tab>
                      <Tabs.Tab value="avenants">Avenants</Tabs.Tab>
                      <Tabs.Tab value="conges">Congés</Tabs.Tab>
                      <Tabs.Tab value="mails">Mails</Tabs.Tab>
                    </>
                  )}
                  {auth?.role?.includes("oodrive") && (
                    <Tabs.Tab value="oodrive">Oodrive</Tabs.Tab>
                  )}
                  {auth?.role?.includes("statistiques") && (
                    <Tabs.Tab value="carte">Carte</Tabs.Tab>
                  )}
                  {auth?.role?.includes("factures") && (
                    <Tabs.Tab value="factures">Factures</Tabs.Tab>
                  )}
                  {auth?.role?.includes("promos") && (
                    <Tabs.Tab value="promos">Promos</Tabs.Tab>
                  )}
                  {auth?.role?.includes("imports") && (
                    <Tabs.Tab value="imports">Imports</Tabs.Tab>
                  )}
                  {auth?.role?.includes("scripts") && (
                    <Tabs.Tab value="scripts">Scripts</Tabs.Tab>
                  )}
                  {auth?.role?.includes("linxo") && (
                    <Tabs.Tab value="linxo">Linxo</Tabs.Tab>
                  )}
                  {auth?.role?.includes("pennylane") && (
                    <Tabs.Tab value="pennylane">Pennylane</Tabs.Tab>
                  )}
                  {auth?.role?.includes("bandeauInformation") && (
                    <Tabs.Tab value="bandeau-information">
                      Bandeau d'information
                    </Tabs.Tab>
                  )}
                </Tabs.List>
              </div>
            </div>
            <div className="blueSpace"></div>
            <div className="content">
              {(auth?.role?.includes("impersonate") ||
                auth?.role?.includes("toCall")) && (
                <Tabs.Panel value="impersonate">
                  <Impersonate />
                </Tabs.Panel>
              )}
              {auth?.role?.includes("edlTemplate") && (
                <Tabs.Panel value="edl-template">
                  <EdlTemplateShow />
                </Tabs.Panel>
              )}
              {auth?.role?.includes("courriers") && (
                <>
                  <Tabs.Panel value="courriers">
                    <CourrierShow type={"courrier"} />
                  </Tabs.Panel>
                  <Tabs.Panel value="cautions">
                    <CourrierShow type={"caution"} />
                  </Tabs.Panel>
                  <Tabs.Panel value="avenants">
                    <CourrierShow type={"avenant"} />
                  </Tabs.Panel>
                  <Tabs.Panel value="conges">
                    <CourrierShow type={"conge"} />
                  </Tabs.Panel>
                  <Tabs.Panel value="mails">
                    <MailShow />
                  </Tabs.Panel>
                </>
              )}
              {auth?.role?.includes("oodrive") && (
                <Tabs.Panel value="oodrive">
                  <Webhooks />
                </Tabs.Panel>
              )}
              {auth?.role?.includes("statistiques") && (
                <Tabs.Panel value="carte">
                  <Map />
                </Tabs.Panel>
              )}
              {auth?.role?.includes("factures") && (
                <Tabs.Panel value="factures">
                  <AdminFactures />
                </Tabs.Panel>
              )}
              {auth?.role?.includes("promos") && (
                <Tabs.Panel value="promos">
                  <Promos />
                </Tabs.Panel>
              )}
              {auth?.role?.includes("imports") && (
                <Tabs.Panel value="imports">
                  <Imports />
                </Tabs.Panel>
              )}
              {auth?.role?.includes("scripts") && (
                <Tabs.Panel value="scripts">
                  <Scripts />
                </Tabs.Panel>
              )}
              {auth?.role?.includes("pennylane") && (
                <Tabs.Panel value="pennylane">
                  <AdminPennylane />
                </Tabs.Panel>
              )}
              {auth?.role?.includes("bandeauInformation") && (
                <Tabs.Panel value="bandeau-information">
                  <BandeauInformationAdmin />
                </Tabs.Panel>
              )}
            </div>
          </Tabs>
        }
      />
    </PageLayout>
  );
}

export default AdminPage;
